
import CadminCompaniesAx         from 'app/actions/company-admin/companies';
import CadminMatchInquiriesAx    from 'app/actions/company-admin/match-inquiries';
import {
  CompanyNonprofitApprovalStatuses as ApprovalStatuses,
}                                from 'app/constants';
import CadminNonprofitsDuck      from 'app/ducks/company-admin/nonprofits';
import history                   from 'app/history';
import paths                     from 'app/paths';
import RoutingSlx                from 'app/selectors/routing';
import CadminSlx                 from 'app/selectors/company-admin/';
import PageSlx                   from 'app/selectors/company-admin/page-matches';

const Types = {
  LOAD: 'CADMIN_PAGE_MATCH_INQS_LOAD',
  SEARCH: 'CADMIN_PAGE_MATCH_INQS_SEARCH',
  APPROVE: 'CADMIN_PAGE_MATCH_INQS_APPROVE',
  BAN: 'CADMIN_PAGE_MATCH_INQS_BAN',
};

const Actions = {

  load: ({params: {companySlug}, query}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.get(companySlug)),
      dispatch(Actions.search(companySlug, query)),
      dispatch(CadminCompaniesAx.getAttentionNumbers(companySlug, {refresh: true})),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

  search: (companyId, params) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminMatchInquiriesAx.search(companyId, params));
    return dispatch({type: Types.SEARCH, promise});
  },

  refresh: () => (dispatch, getState) => {
    const state = getState();
    const companyId = CadminSlx.companyId(state);
    const params = {...PageSlx.searchParams(state)};
    const promise = dispatch(Actions.search(companyId, params));
  },

  approve: (nonprofitId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminNonprofitsDuck.Ax.setApprovalStatus(companyId, nonprofitId, ApprovalStatuses.APPROVED));
    promise.then(() => {
      dispatch(Actions.refresh());
    });
  },

  ban: (nonprofitId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminNonprofitsDuck.Ax.setApprovalStatus(companyId, nonprofitId, ApprovalStatuses.BANNED));
    promise.then(() => {
      dispatch(Actions.refresh());
    });
    return dispatch({type: Types.BAN, promise, nonprofitId});
  },

  setSearchParams: (newParams) => (dispatch, getState) => {
    const state = getState();
    const companySlug = CadminSlx.companySlug(state);
    const currentParams = PageSlx.searchParams(state);
    const params = {...currentParams, ...newParams};
    const path = paths.cadminMatchInquiries(companySlug, params);
    history.push(path);
  },

};

export {
  Types,
};

export default Actions;
